import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import AnalyticsDesktop from "./AnalyticsDesktop";
import AnalyticsMobile from "./AnalyticsMobile";

function Analytics({ app, config, filter }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <AnalyticsMobile app={app} config={config} filter={filter} />
  ) : (
    <AnalyticsDesktop app={app} config={config} filter={filter} />
  );
}

Analytics.defaultProps = {
  app: null,
  config: {},
  filter: "",
};

Analytics.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  filter: PropTypes.string,
};

export default Analytics;
